import { Swiper, Pagination, Navigation, Autoplay } from 'swiper/js/swiper.esm';

const modules = [Pagination, Navigation, Autoplay];

export {
  Swiper,
  modules,
}
